var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-table',{attrs:{"items":_vm.certificados,"fields":_vm.fields,"responsive":"","hover":""},on:{"row-clicked":_vm.onSelectCertificado}})}
var staticRenderFns = []

export { render, staticRenderFns }